// This file was generated by org.multipaz.processor.CodeBuilder, do not edit by hand
package org.multipaz.securearea.software

import org.multipaz.cbor.DataItem
import org.multipaz.securearea.software.SoftwareSecureArea.KeyMetadata
import org.multipaz.cbor.Cbor
import kotlinx.io.bytestring.ByteString
import org.multipaz.cbor.annotation.CborSerializableGenerated
import org.multipaz.cbor.CborMap
import org.multipaz.cbor.Tstr
import org.multipaz.cbor.toDataItem
import org.multipaz.crypto.PrivateKey
import org.multipaz.cbor.Bstr
import org.multipaz.securearea.PassphraseConstraints
import org.multipaz.cbor.buildCborArray
import org.multipaz.crypto.Algorithm
import org.multipaz.securearea.software.SoftwareUserAuthType
import org.multipaz.securearea.toDataItem
import org.multipaz.securearea.fromDataItem

internal fun KeyMetadata.toCbor(): ByteArray {
    return Cbor.encode(toDataItem())
}

@CborSerializableGenerated(schemaId = "ZQhm_YwMdgsTBNuJjP_Zv5HQL2dKaVLwMRH96nxpf8Q")
internal val KeyMetadata_cborSchemaId = ByteString(101, 8, 102, -3, -116, 12, 118, 11, 19, 4, -37, -119, -116, -1, -39, -65, -111, -48, 47, 103, 74, 105, 82, -16, 49, 17, -3, -22, 124, 105, 127, -60)

internal fun KeyMetadata.Companion.fromCbor(data: ByteArray): KeyMetadata {
    return KeyMetadata.fromDataItem(Cbor.decode(data))
}

internal val KeyMetadata.Companion.cborSchemaId: ByteString
    get() = KeyMetadata_cborSchemaId

internal fun KeyMetadata.toDataItem(): DataItem {
    val builder = CborMap.builder()
    builder.put("algorithm", Tstr(this.algorithm.name))
    builder.put("passphraseRequired", this.passphraseRequired.toDataItem())
    val privateKey = this.privateKey
    if (privateKey != null) {
        builder.put("privateKey", privateKey.toDataItem())
    }
    val encryptedPrivateKey = this.encryptedPrivateKey
    if (encryptedPrivateKey != null) {
        builder.put("encryptedPrivateKey", Bstr(encryptedPrivateKey.toByteArray()))
    }
    val encryptedPrivateKeyIv = this.encryptedPrivateKeyIv
    if (encryptedPrivateKeyIv != null) {
        builder.put("encryptedPrivateKeyIv", Bstr(encryptedPrivateKeyIv.toByteArray()))
    }
    builder.put("encodedPublicKey", Bstr(this.encodedPublicKey.toByteArray()))
    val passphraseConstraints = this.passphraseConstraints
    if (passphraseConstraints != null) {
        builder.put("passphraseConstraints", passphraseConstraints.toDataItem())
    }
    val userAuthenticationRequired = this.userAuthenticationRequired
    if (userAuthenticationRequired != null) {
        builder.put("userAuthenticationRequired", userAuthenticationRequired.toDataItem())
    }
    val userAuthenticationTypes = this.userAuthenticationTypes
    if (userAuthenticationTypes != null) {
        val array = userAuthenticationTypes.let {
            buildCborArray {
                for (value in it) {
                    add(Tstr(value.name))
                }
            }
        }
        builder.put("userAuthenticationTypes", array)
    }
    return builder.end().build()
}

internal fun KeyMetadata.Companion.fromDataItem(dataItem: DataItem): KeyMetadata {
    val algorithm = Algorithm.valueOf(dataItem["algorithm"].asTstr)
    val passphraseRequired = dataItem["passphraseRequired"].asBoolean
    val privateKey0 = if (dataItem.hasKey("privateKey")) {
        PrivateKey.fromDataItem(dataItem["privateKey"])
    } else {
        null
    }
    val encryptedPrivateKey0 = if (dataItem.hasKey("encryptedPrivateKey")) {
        dataItem["encryptedPrivateKey"].let { ByteString(it.asBstr) }
    } else {
        null
    }
    val encryptedPrivateKeyIv0 = if (dataItem.hasKey("encryptedPrivateKeyIv")) {
        dataItem["encryptedPrivateKeyIv"].let { ByteString(it.asBstr) }
    } else {
        null
    }
    val encodedPublicKey = ByteString(dataItem["encodedPublicKey"].asBstr)
    val passphraseConstraints0 = if (dataItem.hasKey("passphraseConstraints")) {
        PassphraseConstraints.fromDataItem(dataItem["passphraseConstraints"])
    } else {
        null
    }
    val userAuthenticationRequired0 = if (dataItem.hasKey("userAuthenticationRequired")) {
        dataItem["userAuthenticationRequired"].asBoolean
    } else {
        null
    }
    val userAuthenticationTypes0 = if (dataItem.hasKey("userAuthenticationTypes")) {
        val array0 = dataItem["userAuthenticationTypes"].let {
            buildSet<SoftwareUserAuthType> {
                for (value in it.asArray) {
                    add(SoftwareUserAuthType.valueOf(value.asTstr))
                }
            }
        }
        array0
    } else {
        null
    }
    return KeyMetadata(
        algorithm = algorithm,
        passphraseRequired = passphraseRequired,
        privateKey = privateKey0,
        encryptedPrivateKey = encryptedPrivateKey0,
        encryptedPrivateKeyIv = encryptedPrivateKeyIv0,
        encodedPublicKey = encodedPublicKey,
        passphraseConstraints = passphraseConstraints0,
        userAuthenticationRequired = userAuthenticationRequired0,
        userAuthenticationTypes = userAuthenticationTypes0,
    )
}
